export const propertyParitalTypes = [
    {
        value: "Partial Layout",
        label: "Partial Layout",
      },
      {
        value: "Full Layout",
        label: "Full Layout",
      }
]


export const propertyTypes = [
  {
    label : "Layout",
    value: "fOQZ4CPJQYZikZnFkrxy"
  },
  {
    label : "Plot",
    value: "a1b2c3d4e5f6g7h8i9j0"
  },
  {
    label : "Villa",
    value: "k6QfCzo0QVXutC3MUTfV"
  },
  {
    label : "Apartment",
    value: "xOl7nFLzvXtqVAcSrvIC"
  },
  {
    label : "Acres & Cents",
    value: "h0n4k3gZ3rB45kJKPn"
  },
]